var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvantage03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "performance 1",
    clipPath: "url(#clip0_1_390)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "#ffe600ff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.8874 11.7373C32.5564 8.28402 40.0662 6.63577 47.5379 6.35077C47.5189 12.2408 47.4667 18.1308 47.5094 24.0208C48.3407 23.9305 49.1719 23.826 50.0032 23.6978C50.0459 23.807 50.1267 24.0255 50.1694 24.1348C41.4484 23.3795 32.4282 26.5525 26.3054 32.851C22.1682 28.7233 18.0499 24.5718 13.8984 20.4583C17.4514 17.0003 21.4557 13.9793 25.8874 11.7373Z",
    fill: "#FFE600"
  })), /*#__PURE__*/React.createElement("g", {
    id: "#ffaa32ff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.538 6.35077C59.9688 6.57877 72.3711 11.533 81.1206 20.4678C76.9596 24.5765 72.8365 28.7233 68.7041 32.87C63.7925 27.892 57.1093 24.8425 50.1696 24.1348C50.1268 24.0255 50.046 23.807 50.0033 23.6978C49.172 23.826 48.3408 23.9305 47.5095 24.0208C47.4668 18.1308 47.519 12.2408 47.538 6.35077Z",
    fill: "#FFAA32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "#00d200ff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 50.787C0.86925 39.4535 5.76175 28.443 13.8985 20.4583C18.05 24.5718 22.1683 28.7233 26.3055 32.851C20.7243 38.3943 17.5228 46.1605 17.4895 54.017C11.6613 54.0693 5.82825 53.9885 0 54.0788V50.787Z",
    fill: "#00D200"
  })), /*#__PURE__*/React.createElement("g", {
    id: "#ff1e5aff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M81.1206 20.4678C89.4474 28.7945 94.4824 40.2278 95.0001 51.9935V53.9363C89.2669 54.1928 83.5289 53.8935 77.7956 54.0645C77.7196 54.3305 77.5771 54.8673 77.5011 55.1333C77.8051 46.9205 74.6084 38.6128 68.7041 32.87C72.8366 28.7233 76.9596 24.5765 81.1206 20.4678Z",
    fill: "#FF1E5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "#001428ff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M41.292 47.842C43.667 45.4718 47.4147 44.5978 50.5545 45.828C53.3285 46.797 55.0432 49.3335 56.7627 51.547C61.8072 58.368 66.4337 65.4835 71.0507 72.5943C72.224 74.556 74.6418 76.9025 72.7892 79.23C62.1872 68.8703 51.8085 58.2873 41.292 47.842Z",
    fill: "#001428"
  })), /*#__PURE__*/React.createElement("g", {
    id: "#003c50ff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M39.3205 57.1378C38.0618 53.9838 38.969 50.2598 41.2918 47.842C51.8083 58.2873 62.187 68.8703 72.789 79.23C71.592 80.1183 70.0388 80.2513 68.799 79.3725C60.7003 74.043 52.4875 68.8608 44.7165 63.0515C42.6028 61.4223 40.2468 59.7598 39.3205 57.1378Z",
    fill: "#003C50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "#9bff00ff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M0 54.0787C5.82825 53.9885 11.6613 54.0692 17.4895 54.017C17.4563 61.4697 20.3158 68.913 25.4315 74.3422C26.2153 75.2115 27.2365 76.133 27.1178 77.425C26.999 78.7645 25.8258 79.6195 24.9708 80.5267C22.3868 82.992 19.9975 85.6662 17.328 88.0317C16.3638 89.0435 14.8533 88.635 14.022 87.6897C5.48625 79.3962 0.456 67.7207 0 55.8457V54.0787Z",
    fill: "#9BFF00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "#c40050ff"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M77.7953 54.0645C83.5286 53.8935 89.2666 54.1928 94.9998 53.9363V57.1378C94.1686 68.5568 89.2666 79.705 81.0206 87.6993C80.1941 88.654 78.6551 89.1195 77.6813 88.0935C74.5986 85.3195 71.8293 82.2083 68.7988 79.3725C70.0386 80.2513 71.5918 80.1183 72.7888 79.23C74.6413 76.9025 72.2236 74.556 71.0503 72.5943C74.9976 67.6448 77.1826 61.4365 77.5008 55.1333C77.5768 54.8673 77.7193 54.3305 77.7953 54.0645Z",
    fill: "#C40050"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantage03);
export default __webpack_public_path__ + "static/media/advantage-03.921608a624d4d9026e8ace43b0c06a3f.svg";
export { ForwardRef as ReactComponent };